module.exports = __webpack_public_path__ + "assets/favicons/apple-touch-icon.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=assets/favicons/[name].[ext]!./client/app/assets/favicons/apple-touch-icon.png
// module id = 1234
// module chunks = 1